import api from "./index";
import { ENDPOINTS } from "./endpoints";

// CREATE
export const createMasterProduct = (data) =>
  api.post(ENDPOINTS.MASTER_PRODUCTS.CREATE, data);

// LIST
export const listMasterProductsByParams = (data) =>
  api.post(ENDPOINTS.MASTER_PRODUCTS.LIST, data);

// GET BY ID
export const getMasterProductById = (id) =>
  api.get(ENDPOINTS.MASTER_PRODUCTS.BY_ID(id));

// UPDATE
export const updateMasterProduct = (id, data) =>
  api.put(ENDPOINTS.MASTER_PRODUCTS.UPDATE(id), data);

// DELETE
export const deleteMasterProduct = (id) =>
  api.delete(ENDPOINTS.MASTER_PRODUCTS.DELETE(id));

// GET SPECS
export const getSpecsByProduct = (product_id) =>
  api.get(ENDPOINTS.MASTER_PRODUCTS.GET_SPECS(product_id));

export const getMasterProductSpecs = (id) =>
  api.get(ENDPOINTS.MASTER_PRODUCTS.GET_MASTER_SPECS(id));